import * as posModels from "./posModels";
import describeNetworkError from "../describeNetworkError";
import instance from "./instance";
import logger from "../sentryLogger";
import {logs as urls} from "./urls";

export function logGeneralAction(
    action: string,
    stationMode: posModels.StationMode,
): Promise<void> {
    return instance
        .request({
            url: urls.general,
            method: "POST",
            data: {
                action,
                stationMode,
                timestamp: new Date().toISOString(),
            },
        })
        .then((response) => response.data)
        .catch((err) => {
            const errorMessage = describeNetworkError(err).join("\n");
            logger.warn(
                "An unexpected error occurred when logging general action.",
                {errorMessage, action},
            );
        });
}

export function logManagerAction(
    action: string,
    managerId: string,
    stationMode: posModels.StationMode,
): Promise<void> {
    return instance
        .request({
            url: urls.manager,
            method: "POST",
            data: {
                action,
                managerId,
                stationMode,
                timestamp: new Date().toISOString(),
            },
        })
        .then((response) => response.data)
        .catch((err) => {
            const errorMessage = describeNetworkError(err).join("\n");
            logger.warn(
                "An unexpected error occurred when logging manager action.",
                {errorMessage, action, managerId},
            );
        });
}
